const initialState = {
	data: [],
	total: 0,
	params: {},
	selectedCasinoType: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const casinotype = (state = initialState, action) => {
	switch (action.type) {
		case 'CASINOTYPE_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'CASINOTYPE_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'CASINOTYPE_UPDATE_DATA':
			return {
				...state,
				data: state.data.map((item) => (item.id === action.index ? action.data : item)),
			}
		case 'CASINOTYPE_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		case 'CASINOTYPE_GET_CURRENT':
			return {
				...state,
				selectedCasinoType: action.selectedCasinoType,
			}
		case 'CASINOTYPE_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return state
	}
}

export default casinotype
